import React from 'react';
import { IconLookup } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';
import { Heading, Icon } from '@innovationnorway/cl-react';
interface SubHeaderProps {
  iconDefiniton: IconLookup;
  title: string;
}
const Referralprocess: React.FC = () => {
  const { t: tHelpAndSupport } = useTranslation('onboarding');
  const SubHeader = ({ iconDefiniton, title }: SubHeaderProps) => {
    return (
      <div>
        <span className="font-weight--bold">
          <Icon
            prefix={iconDefiniton.prefix === 'fas' ? 'fass' : 'fasr'}
            iconName={iconDefiniton.iconName as string}
            className="display--inline margin-right--1"
          />
          {title}
        </span>
      </div>
    );
  };
  return (
    <>
      <Heading level={2}>{tHelpAndSupport('commonQuestions.Referralprocess')}</Heading>
      <div className="stack-medium">
        <SubHeader
          iconDefiniton={{ prefix: 'fal', iconName: 'list-check' }}
          title={tHelpAndSupport('commonQuestions.StepTitles.ChooseActor')}
        />
        <p>{tHelpAndSupport('commonQuestions.StepDescriptions.ChooseActor')}</p>
      </div>
      <div className="stack-medium">
        <SubHeader
          iconDefiniton={{ prefix: 'fal', iconName: 'envelope' }}
          title={tHelpAndSupport('commonQuestions.StepTitles.WriteReferral')}
        />
        <p>{tHelpAndSupport('commonQuestions.StepDescriptions.WriteReferral')}</p>
      </div>
      <div className="stack-medium">
        <SubHeader
          iconDefiniton={{ prefix: 'fal', iconName: 'paper-plane' }}
          title={tHelpAndSupport('commonQuestions.StepTitles.SendReferral')}
        />
        <p>{tHelpAndSupport('commonQuestions.StepDescriptions.SendReferral')}</p>
      </div>
      <div className="stack-medium">
        <SubHeader
          iconDefiniton={{ prefix: 'fal', iconName: 'square-check' }}
          title={tHelpAndSupport('commonQuestions.StepTitles.KeepWorking')}
        />
        <p>{tHelpAndSupport('commonQuestions.StepDescriptions.Archive')}</p>
      </div>
    </>
  );
};
export default Referralprocess;
